import cookie from "react-cookies";
import { RIMS_COOKIE_CONSTANTS } from "../constants";

export const useCookieData = () => {
  const token = cookie.load(RIMS_COOKIE_CONSTANTS.LOGIN_TOKEN);
  const domain = cookie.load(RIMS_COOKIE_CONSTANTS.DOMAIN);
  const tenantId = cookie.load(RIMS_COOKIE_CONSTANTS.USER_TENANT_ID);
  const userId = cookie.load(RIMS_COOKIE_CONSTANTS.USER_ID);
  const userInfo = cookie.load(RIMS_COOKIE_CONSTANTS.USER_INFO);
  const userPrivileges = cookie.load(RIMS_COOKIE_CONSTANTS.USER_PRIVILEGES);
  const userEmail = cookie.load(RIMS_COOKIE_CONSTANTS.USER_EMAIL);
  const userName = cookie.load(RIMS_COOKIE_CONSTANTS.USER_NAME);
  return { token, tenantId, domain, userId, userInfo, userPrivileges, userEmail, userName };
};
